import Je, { useState as Et, useEffect as Nt } from "react";
import { L as Ut } from "./chunk.Bv8Vef6I.js";
import { _ as Wt, L as Ht } from "./chunk.Czw-e4a5.js";
import { _ as It, a as m } from "./chunk.BUtkG-md.js";
import { g as Lt } from "./chunk.DaMA6jEr.js";
const et = (a, n, r) => {
  const t = a[n];
  return t ? typeof t == "function" ? t() : Promise.resolve(t) : new Promise((e, i) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      i.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + n + (n.split("/").length !== r ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
function b(a) {
  if (a === null || a === !0 || a === !1)
    return NaN;
  var n = Number(a);
  return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
}
function z(a) {
  "@babel/helpers - typeof";
  return z = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, z(a);
}
function d(a, n) {
  if (n.length < a)
    throw new TypeError(a + " argument" + (a > 1 ? "s" : "") + " required, but only " + n.length + " present");
}
function c(a) {
  d(1, arguments);
  var n = Object.prototype.toString.call(a);
  return a instanceof Date || z(a) === "object" && n === "[object Date]" ? new Date(a.getTime()) : typeof a == "number" || n === "[object Number]" ? new Date(a) : ((typeof a == "string" || n === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Te(a, n) {
  d(2, arguments);
  var r = c(a), t = b(n);
  return isNaN(t) ? /* @__PURE__ */ new Date(NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Ce(a, n) {
  d(2, arguments);
  var r = c(a).getTime(), t = b(n);
  return new Date(r + t);
}
function Ft(a, n) {
  d(2, arguments);
  var r = b(n);
  return Ce(a, r * 1e3);
}
var St = 6e4;
function At(a, n) {
  d(2, arguments);
  var r = b(n);
  return Ce(a, r * St);
}
var $t = 36e5;
function Rt(a, n) {
  d(2, arguments);
  var r = b(n);
  return Ce(a, r * $t);
}
function qt(a, n) {
  d(2, arguments);
  var r = b(n), t = r * 7;
  return Te(a, t);
}
function be(a, n) {
  d(2, arguments);
  var r = c(a), t = b(n);
  if (isNaN(t))
    return /* @__PURE__ */ new Date(NaN);
  if (!t)
    return r;
  var e = r.getDate(), i = new Date(r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  var o = i.getDate();
  return e >= o ? i : (r.setFullYear(i.getFullYear(), i.getMonth(), e), r);
}
function tt(a, n) {
  d(2, arguments);
  var r = b(n);
  return be(a, r * 12);
}
function Qt(a, n) {
  d(2, arguments);
  var r = c(a), t = c(n);
  return r.getFullYear() - t.getFullYear();
}
function me(a, n) {
  d(2, arguments);
  var r = c(a), t = c(n), e = r.getTime() - t.getTime();
  return e < 0 ? -1 : e > 0 ? 1 : e;
}
function Bt(a, n) {
  d(2, arguments);
  var r = c(a), t = c(n), e = me(r, t), i = Math.abs(Qt(r, t));
  r.setFullYear(1584), t.setFullYear(1584);
  var o = me(r, t) === -e, s = e * (i - Number(o));
  return s === 0 ? 0 : s;
}
function zt(a, n) {
  d(2, arguments);
  var r = c(a), t = c(n), e = r.getFullYear() - t.getFullYear(), i = r.getMonth() - t.getMonth();
  return e * 12 + i;
}
function Fe(a) {
  d(1, arguments);
  var n = c(a);
  return n.setHours(23, 59, 59, 999), n;
}
function Se(a) {
  d(1, arguments);
  var n = c(a), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Gt(a) {
  d(1, arguments);
  var n = c(a);
  return Fe(n).getTime() === Se(n).getTime();
}
function ft(a, n) {
  d(2, arguments);
  var r = c(a), t = c(n), e = me(r, t), i = Math.abs(zt(r, t)), o;
  if (i < 1)
    o = 0;
  else {
    r.getMonth() === 1 && r.getDate() > 27 && r.setDate(30), r.setMonth(r.getMonth() - e * i);
    var s = me(r, t) === -e;
    Gt(c(a)) && i === 1 && me(a, t) === 1 && (s = !1), o = e * (i - Number(s));
  }
  return o === 0 ? 0 : o;
}
var rt = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(n) {
    return n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  // Math.trunc is not supported by IE
}, Xt = "trunc";
function ve(a) {
  return a ? rt[a] : rt[Xt];
}
function Zt(a, n, r) {
  d(2, arguments);
  var t = ft(a, n) / 3;
  return ve(void 0)(t);
}
function xe(a) {
  var n = new Date(Date.UTC(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), a.getSeconds(), a.getMilliseconds()));
  return n.setUTCFullYear(a.getFullYear()), a.getTime() - n.getTime();
}
function ne(a) {
  d(1, arguments);
  var n = c(a);
  return n.setHours(0, 0, 0, 0), n;
}
var Vt = 864e5;
function Kt(a, n) {
  d(2, arguments);
  var r = ne(a), t = ne(n), e = r.getTime() - xe(r), i = t.getTime() - xe(t);
  return Math.round((e - i) / Vt);
}
function nt(a, n) {
  var r = a.getFullYear() - n.getFullYear() || a.getMonth() - n.getMonth() || a.getDate() - n.getDate() || a.getHours() - n.getHours() || a.getMinutes() - n.getMinutes() || a.getSeconds() - n.getSeconds() || a.getMilliseconds() - n.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function mt(a, n) {
  d(2, arguments);
  var r = c(a), t = c(n), e = nt(r, t), i = Math.abs(Kt(r, t));
  r.setDate(r.getDate() - e * i);
  var o = +(nt(r, t) === -e), s = e * (i - o);
  return s === 0 ? 0 : s;
}
function Jt(a, n, r) {
  d(2, arguments);
  var t = mt(a, n) / 7;
  return ve(void 0)(t);
}
var ke = 6e4, Oe = 36e5, er = 1e3;
function Pe(a, n) {
  return d(2, arguments), c(a).getTime() - c(n).getTime();
}
function tr(a, n, r) {
  d(2, arguments);
  var t = Pe(a, n) / Oe;
  return ve(void 0)(t);
}
function rr(a, n, r) {
  d(2, arguments);
  var t = Pe(a, n) / ke;
  return ve(void 0)(t);
}
function nr(a, n, r) {
  d(2, arguments);
  var t = Pe(a, n) / 1e3;
  return ve(void 0)(t);
}
function ar(a, n) {
  var r;
  d(1, arguments);
  var t = a, e = c(t.start), i = c(t.end), o = i.getTime();
  if (!(e.getTime() <= o))
    throw new RangeError("Invalid interval");
  var s = [], u = e;
  u.setHours(0, 0, 0, 0);
  var l = Number((r = void 0) !== null && r !== void 0 ? r : 1);
  if (l < 1 || isNaN(l)) throw new RangeError("`options.step` must be a number greater than 1");
  for (; u.getTime() <= o; )
    s.push(c(u)), u.setDate(u.getDate() + l), u.setHours(0, 0, 0, 0);
  return s;
}
var or = {};
function R() {
  return or;
}
function Ue(a, n) {
  var r, t, e, i, o, s, u, l;
  d(1, arguments);
  var h = R(), v = b((r = (t = (e = (i = n == null ? void 0 : n.weekStartsOn) !== null && i !== void 0 ? i : n == null || (o = n.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && e !== void 0 ? e : h.weekStartsOn) !== null && t !== void 0 ? t : (u = h.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(v >= 0 && v <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var g = c(a), p = g.getDay(), _ = (p < v ? -7 : 0) + 6 - (p - v);
  return g.setDate(g.getDate() + _), g.setHours(23, 59, 59, 999), g;
}
function We(a) {
  d(1, arguments);
  var n = c(a), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function ir(a) {
  return d(1, arguments), a instanceof Date || z(a) === "object" && Object.prototype.toString.call(a) === "[object Date]";
}
function vt(a) {
  if (d(1, arguments), !ir(a) && typeof a != "number")
    return !1;
  var n = c(a);
  return !isNaN(Number(n));
}
function ht(a, n) {
  d(2, arguments);
  var r = b(n);
  return Ce(a, -r);
}
var sr = 864e5;
function ur(a) {
  d(1, arguments);
  var n = c(a), r = n.getTime();
  n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
  var t = n.getTime(), e = r - t;
  return Math.floor(e / sr) + 1;
}
function ae(a) {
  d(1, arguments);
  var n = 1, r = c(a), t = r.getUTCDay(), e = (t < n ? 7 : 0) + t - n;
  return r.setUTCDate(r.getUTCDate() - e), r.setUTCHours(0, 0, 0, 0), r;
}
function pt(a) {
  d(1, arguments);
  var n = c(a), r = n.getUTCFullYear(), t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(r + 1, 0, 4), t.setUTCHours(0, 0, 0, 0);
  var e = ae(t), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(r, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = ae(i);
  return n.getTime() >= e.getTime() ? r + 1 : n.getTime() >= o.getTime() ? r : r - 1;
}
function lr(a) {
  d(1, arguments);
  var n = pt(a), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var t = ae(r);
  return t;
}
var dr = 6048e5;
function gt(a) {
  d(1, arguments);
  var n = c(a), r = ae(n).getTime() - lr(n).getTime();
  return Math.round(r / dr) + 1;
}
function te(a, n) {
  var r, t, e, i, o, s, u, l;
  d(1, arguments);
  var h = R(), v = b((r = (t = (e = (i = n == null ? void 0 : n.weekStartsOn) !== null && i !== void 0 ? i : n == null || (o = n.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && e !== void 0 ? e : h.weekStartsOn) !== null && t !== void 0 ? t : (u = h.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(v >= 0 && v <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var g = c(a), p = g.getUTCDay(), _ = (p < v ? 7 : 0) + p - v;
  return g.setUTCDate(g.getUTCDate() - _), g.setUTCHours(0, 0, 0, 0), g;
}
function Re(a, n) {
  var r, t, e, i, o, s, u, l;
  d(1, arguments);
  var h = c(a), v = h.getUTCFullYear(), g = R(), p = b((r = (t = (e = (i = n == null ? void 0 : n.firstWeekContainsDate) !== null && i !== void 0 ? i : n == null || (o = n.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && e !== void 0 ? e : g.firstWeekContainsDate) !== null && t !== void 0 ? t : (u = g.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(p >= 1 && p <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var _ = /* @__PURE__ */ new Date(0);
  _.setUTCFullYear(v + 1, 0, p), _.setUTCHours(0, 0, 0, 0);
  var U = te(_, n), Y = /* @__PURE__ */ new Date(0);
  Y.setUTCFullYear(v, 0, p), Y.setUTCHours(0, 0, 0, 0);
  var H = te(Y, n);
  return h.getTime() >= U.getTime() ? v + 1 : h.getTime() >= H.getTime() ? v : v - 1;
}
function cr(a, n) {
  var r, t, e, i, o, s, u, l;
  d(1, arguments);
  var h = R(), v = b((r = (t = (e = (i = n == null ? void 0 : n.firstWeekContainsDate) !== null && i !== void 0 ? i : n == null || (o = n.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && e !== void 0 ? e : h.firstWeekContainsDate) !== null && t !== void 0 ? t : (u = h.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), g = Re(a, n), p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(g, 0, v), p.setUTCHours(0, 0, 0, 0);
  var _ = te(p, n);
  return _;
}
var fr = 6048e5;
function wt(a, n) {
  d(1, arguments);
  var r = c(a), t = te(r, n).getTime() - cr(r, n).getTime();
  return Math.round(t / fr) + 1;
}
function w(a, n) {
  for (var r = a < 0 ? "-" : "", t = Math.abs(a).toString(); t.length < n; )
    t = "0" + t;
  return r + t;
}
var Z = {
  // Year
  y: function(n, r) {
    var t = n.getUTCFullYear(), e = t > 0 ? t : 1 - t;
    return w(r === "yy" ? e % 100 : e, r.length);
  },
  // Month
  M: function(n, r) {
    var t = n.getUTCMonth();
    return r === "M" ? String(t + 1) : w(t + 1, 2);
  },
  // Day of the month
  d: function(n, r) {
    return w(n.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(n, r) {
    var t = n.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(n, r) {
    return w(n.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(n, r) {
    return w(n.getUTCHours(), r.length);
  },
  // Minute
  m: function(n, r) {
    return w(n.getUTCMinutes(), r.length);
  },
  // Second
  s: function(n, r) {
    return w(n.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(n, r) {
    var t = r.length, e = n.getUTCMilliseconds(), i = Math.floor(e * Math.pow(10, t - 3));
    return w(i, r.length);
  }
}, re = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, mr = {
  // Era
  G: function(n, r, t) {
    var e = n.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(e, {
          width: "abbreviated"
        });
      case "GGGGG":
        return t.era(e, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return t.era(e, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(n, r, t) {
    if (r === "yo") {
      var e = n.getUTCFullYear(), i = e > 0 ? e : 1 - e;
      return t.ordinalNumber(i, {
        unit: "year"
      });
    }
    return Z.y(n, r);
  },
  // Local week-numbering year
  Y: function(n, r, t, e) {
    var i = Re(n, e), o = i > 0 ? i : 1 - i;
    if (r === "YY") {
      var s = o % 100;
      return w(s, 2);
    }
    return r === "Yo" ? t.ordinalNumber(o, {
      unit: "year"
    }) : w(o, r.length);
  },
  // ISO week-numbering year
  R: function(n, r) {
    var t = pt(n);
    return w(t, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, r) {
    var t = n.getUTCFullYear();
    return w(t, r.length);
  },
  // Quarter
  Q: function(n, r, t) {
    var e = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(e);
      case "QQ":
        return w(e, 2);
      case "Qo":
        return t.ordinalNumber(e, {
          unit: "quarter"
        });
      case "QQQ":
        return t.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, r, t) {
    var e = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(e);
      case "qq":
        return w(e, 2);
      case "qo":
        return t.ordinalNumber(e, {
          unit: "quarter"
        });
      case "qqq":
        return t.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(e, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, r, t) {
    var e = n.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return Z.M(n, r);
      case "Mo":
        return t.ordinalNumber(e + 1, {
          unit: "month"
        });
      case "MMM":
        return t.month(e, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(e, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(n, r, t) {
    var e = n.getUTCMonth();
    switch (r) {
      case "L":
        return String(e + 1);
      case "LL":
        return w(e + 1, 2);
      case "Lo":
        return t.ordinalNumber(e + 1, {
          unit: "month"
        });
      case "LLL":
        return t.month(e, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(e, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(e, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(n, r, t, e) {
    var i = wt(n, e);
    return r === "wo" ? t.ordinalNumber(i, {
      unit: "week"
    }) : w(i, r.length);
  },
  // ISO week of year
  I: function(n, r, t) {
    var e = gt(n);
    return r === "Io" ? t.ordinalNumber(e, {
      unit: "week"
    }) : w(e, r.length);
  },
  // Day of the month
  d: function(n, r, t) {
    return r === "do" ? t.ordinalNumber(n.getUTCDate(), {
      unit: "date"
    }) : Z.d(n, r);
  },
  // Day of year
  D: function(n, r, t) {
    var e = ur(n);
    return r === "Do" ? t.ordinalNumber(e, {
      unit: "dayOfYear"
    }) : w(e, r.length);
  },
  // Day of week
  E: function(n, r, t) {
    var e = n.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(e, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(e, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, r, t, e) {
    var i = n.getUTCDay(), o = (i - e.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return w(o, 2);
      case "eo":
        return t.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return t.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, r, t, e) {
    var i = n.getUTCDay(), o = (i - e.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return w(o, r.length);
      case "co":
        return t.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return t.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, r, t) {
    var e = n.getUTCDay(), i = e === 0 ? 7 : e;
    switch (r) {
      case "i":
        return String(i);
      case "ii":
        return w(i, r.length);
      case "io":
        return t.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return t.day(e, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(e, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(e, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, r, t) {
    var e = n.getUTCHours(), i = e / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, r, t) {
    var e = n.getUTCHours(), i;
    switch (e === 12 ? i = re.noon : e === 0 ? i = re.midnight : i = e / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, r, t) {
    var e = n.getUTCHours(), i;
    switch (e >= 17 ? i = re.evening : e >= 12 ? i = re.afternoon : e >= 4 ? i = re.morning : i = re.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, r, t) {
    if (r === "ho") {
      var e = n.getUTCHours() % 12;
      return e === 0 && (e = 12), t.ordinalNumber(e, {
        unit: "hour"
      });
    }
    return Z.h(n, r);
  },
  // Hour [0-23]
  H: function(n, r, t) {
    return r === "Ho" ? t.ordinalNumber(n.getUTCHours(), {
      unit: "hour"
    }) : Z.H(n, r);
  },
  // Hour [0-11]
  K: function(n, r, t) {
    var e = n.getUTCHours() % 12;
    return r === "Ko" ? t.ordinalNumber(e, {
      unit: "hour"
    }) : w(e, r.length);
  },
  // Hour [1-24]
  k: function(n, r, t) {
    var e = n.getUTCHours();
    return e === 0 && (e = 24), r === "ko" ? t.ordinalNumber(e, {
      unit: "hour"
    }) : w(e, r.length);
  },
  // Minute
  m: function(n, r, t) {
    return r === "mo" ? t.ordinalNumber(n.getUTCMinutes(), {
      unit: "minute"
    }) : Z.m(n, r);
  },
  // Second
  s: function(n, r, t) {
    return r === "so" ? t.ordinalNumber(n.getUTCSeconds(), {
      unit: "second"
    }) : Z.s(n, r);
  },
  // Fraction of second
  S: function(n, r) {
    return Z.S(n, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, r, t, e) {
    var i = e._originalDate || n, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      case "X":
        return ot(o);
      case "XXXX":
      case "XX":
        return J(o);
      case "XXXXX":
      case "XXX":
      default:
        return J(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, r, t, e) {
    var i = e._originalDate || n, o = i.getTimezoneOffset();
    switch (r) {
      case "x":
        return ot(o);
      case "xxxx":
      case "xx":
        return J(o);
      case "xxxxx":
      case "xxx":
      default:
        return J(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, r, t, e) {
    var i = e._originalDate || n, o = i.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + at(o, ":");
      case "OOOO":
      default:
        return "GMT" + J(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, r, t, e) {
    var i = e._originalDate || n, o = i.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + at(o, ":");
      case "zzzz":
      default:
        return "GMT" + J(o, ":");
    }
  },
  // Seconds timestamp
  t: function(n, r, t, e) {
    var i = e._originalDate || n, o = Math.floor(i.getTime() / 1e3);
    return w(o, r.length);
  },
  // Milliseconds timestamp
  T: function(n, r, t, e) {
    var i = e._originalDate || n, o = i.getTime();
    return w(o, r.length);
  }
};
function at(a, n) {
  var r = a > 0 ? "-" : "+", t = Math.abs(a), e = Math.floor(t / 60), i = t % 60;
  if (i === 0)
    return r + String(e);
  var o = n;
  return r + String(e) + o + w(i, 2);
}
function ot(a, n) {
  if (a % 60 === 0) {
    var r = a > 0 ? "-" : "+";
    return r + w(Math.abs(a) / 60, 2);
  }
  return J(a, n);
}
function J(a, n) {
  var r = n || "", t = a > 0 ? "-" : "+", e = Math.abs(a), i = w(Math.floor(e / 60), 2), o = w(e % 60, 2);
  return t + i + r + o;
}
var it = function(n, r) {
  switch (n) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, yt = function(n, r) {
  switch (n) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, vr = function(n, r) {
  var t = n.match(/(P+)(p+)?/) || [], e = t[1], i = t[2];
  if (!i)
    return it(n, r);
  var o;
  switch (e) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", it(e, r)).replace("{{time}}", yt(i, r));
}, Ae = {
  p: yt,
  P: vr
}, hr = ["D", "DD"], pr = ["YY", "YYYY"];
function Tt(a) {
  return hr.indexOf(a) !== -1;
}
function bt(a) {
  return pr.indexOf(a) !== -1;
}
function De(a, n, r) {
  if (a === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(n, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (a === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(n, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (a === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(n, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (a === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(n, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var gr = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, wr = function(n, r, t) {
  var e, i = gr[n];
  return typeof i == "string" ? e = i : r === 1 ? e = i.one : e = i.other.replace("{{count}}", r.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + e : e + " ago" : e;
};
function He(a) {
  return function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.width ? String(n.width) : a.defaultWidth, t = a.formats[r] || a.formats[a.defaultWidth];
    return t;
  };
}
var yr = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Tr = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, br = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, xr = {
  date: He({
    formats: yr,
    defaultWidth: "full"
  }),
  time: He({
    formats: Tr,
    defaultWidth: "full"
  }),
  dateTime: He({
    formats: br,
    defaultWidth: "full"
  })
}, Dr = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, _r = function(n, r, t, e) {
  return Dr[n];
};
function le(a) {
  return function(n, r) {
    var t = r != null && r.context ? String(r.context) : "standalone", e;
    if (t === "formatting" && a.formattingValues) {
      var i = a.defaultFormattingWidth || a.defaultWidth, o = r != null && r.width ? String(r.width) : i;
      e = a.formattingValues[o] || a.formattingValues[i];
    } else {
      var s = a.defaultWidth, u = r != null && r.width ? String(r.width) : a.defaultWidth;
      e = a.values[u] || a.values[s];
    }
    var l = a.argumentCallback ? a.argumentCallback(n) : n;
    return e[l];
  };
}
var Mr = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Cr = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, kr = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Or = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Pr = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, jr = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Yr = function(n, r) {
  var t = Number(n), e = t % 100;
  if (e > 20 || e < 10)
    switch (e % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Er = {
  ordinalNumber: Yr,
  era: le({
    values: Mr,
    defaultWidth: "wide"
  }),
  quarter: le({
    values: Cr,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: le({
    values: kr,
    defaultWidth: "wide"
  }),
  day: le({
    values: Or,
    defaultWidth: "wide"
  }),
  dayPeriod: le({
    values: Pr,
    defaultWidth: "wide",
    formattingValues: jr,
    defaultFormattingWidth: "wide"
  })
};
function de(a) {
  return function(n) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = r.width, e = t && a.matchPatterns[t] || a.matchPatterns[a.defaultMatchWidth], i = n.match(e);
    if (!i)
      return null;
    var o = i[0], s = t && a.parsePatterns[t] || a.parsePatterns[a.defaultParseWidth], u = Array.isArray(s) ? Ur(s, function(v) {
      return v.test(o);
    }) : Nr(s, function(v) {
      return v.test(o);
    }), l;
    l = a.valueCallback ? a.valueCallback(u) : u, l = r.valueCallback ? r.valueCallback(l) : l;
    var h = n.slice(o.length);
    return {
      value: l,
      rest: h
    };
  };
}
function Nr(a, n) {
  for (var r in a)
    if (a.hasOwnProperty(r) && n(a[r]))
      return r;
}
function Ur(a, n) {
  for (var r = 0; r < a.length; r++)
    if (n(a[r]))
      return r;
}
function Wr(a) {
  return function(n) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.match(a.matchPattern);
    if (!t) return null;
    var e = t[0], i = n.match(a.parsePattern);
    if (!i) return null;
    var o = a.valueCallback ? a.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var s = n.slice(e.length);
    return {
      value: o,
      rest: s
    };
  };
}
var Hr = /^(\d+)(th|st|nd|rd)?/i, Ir = /\d+/i, Lr = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Fr = {
  any: [/^b/i, /^(a|c)/i]
}, Sr = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Ar = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, $r = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Rr = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, qr = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Qr = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Br = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, zr = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Gr = {
  ordinalNumber: Wr({
    matchPattern: Hr,
    parsePattern: Ir,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: de({
    matchPatterns: Lr,
    defaultMatchWidth: "wide",
    parsePatterns: Fr,
    defaultParseWidth: "any"
  }),
  quarter: de({
    matchPatterns: Sr,
    defaultMatchWidth: "wide",
    parsePatterns: Ar,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: de({
    matchPatterns: $r,
    defaultMatchWidth: "wide",
    parsePatterns: Rr,
    defaultParseWidth: "any"
  }),
  day: de({
    matchPatterns: qr,
    defaultMatchWidth: "wide",
    parsePatterns: Qr,
    defaultParseWidth: "any"
  }),
  dayPeriod: de({
    matchPatterns: Br,
    defaultMatchWidth: "any",
    parsePatterns: zr,
    defaultParseWidth: "any"
  })
}, je = {
  code: "en-US",
  formatDistance: wr,
  formatLong: xr,
  formatRelative: _r,
  localize: Er,
  match: Gr,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const st = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: je
}, Symbol.toStringTag, { value: "Module" }));
var Xr = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Zr = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Vr = /^'([^]*?)'?$/, Kr = /''/g, Jr = /[a-zA-Z]/;
function en(a, n, r) {
  var t, e, i, o, s, u, l, h, v, g, p, _, U, Y, H, S, q, Q;
  d(2, arguments);
  var V = String(n), W = R(), L = (t = (e = r == null ? void 0 : r.locale) !== null && e !== void 0 ? e : W.locale) !== null && t !== void 0 ? t : je, B = b((i = (o = (s = (u = r == null ? void 0 : r.firstWeekContainsDate) !== null && u !== void 0 ? u : r == null || (l = r.locale) === null || l === void 0 || (h = l.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && s !== void 0 ? s : W.firstWeekContainsDate) !== null && o !== void 0 ? o : (v = W.locale) === null || v === void 0 || (g = v.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(B >= 1 && B <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var G = b((p = (_ = (U = (Y = r == null ? void 0 : r.weekStartsOn) !== null && Y !== void 0 ? Y : r == null || (H = r.locale) === null || H === void 0 || (S = H.options) === null || S === void 0 ? void 0 : S.weekStartsOn) !== null && U !== void 0 ? U : W.weekStartsOn) !== null && _ !== void 0 ? _ : (q = W.locale) === null || q === void 0 || (Q = q.options) === null || Q === void 0 ? void 0 : Q.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(G >= 0 && G <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!L.localize)
    throw new RangeError("locale must contain localize property");
  if (!L.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var X = c(a);
  if (!vt(X))
    throw new RangeError("Invalid time value");
  var oe = xe(X), ie = ht(X, oe), se = {
    firstWeekContainsDate: B,
    weekStartsOn: G,
    locale: L,
    _originalDate: X
  }, Ye = V.match(Zr).map(function(N) {
    var I = N[0];
    if (I === "p" || I === "P") {
      var K = Ae[I];
      return K(N, L.formatLong);
    }
    return N;
  }).join("").match(Xr).map(function(N) {
    if (N === "''")
      return "'";
    var I = N[0];
    if (I === "'")
      return tn(N);
    var K = mr[I];
    if (K)
      return !(r != null && r.useAdditionalWeekYearTokens) && bt(N) && De(N, n, String(a)), !(r != null && r.useAdditionalDayOfYearTokens) && Tt(N) && De(N, n, String(a)), K(ie, N, L.localize, se);
    if (I.match(Jr))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + I + "`");
    return N;
  }).join("");
  return Ye;
}
function tn(a) {
  var n = a.match(Vr);
  return n ? n[1].replace(Kr, "'") : a;
}
function rn(a) {
  d(1, arguments);
  var n = c(a), r = n.getDate();
  return r;
}
function xt(a) {
  d(1, arguments);
  var n = c(a), r = n.getFullYear(), t = n.getMonth(), e = /* @__PURE__ */ new Date(0);
  return e.setFullYear(r, t + 1, 0), e.setHours(0, 0, 0, 0), e.getDate();
}
function nn(a) {
  d(1, arguments);
  var n = c(a), r = n.getHours();
  return r;
}
function an(a) {
  d(1, arguments);
  var n = c(a), r = n.getMinutes();
  return r;
}
function on(a) {
  d(1, arguments);
  var n = c(a), r = n.getMonth();
  return r;
}
function sn(a) {
  d(1, arguments);
  var n = c(a), r = n.getSeconds();
  return r;
}
function un(a) {
  d(1, arguments);
  var n = c(a), r = n.getMilliseconds();
  return r;
}
function ee(a, n) {
  var r, t, e, i, o, s, u, l;
  d(1, arguments);
  var h = R(), v = b((r = (t = (e = (i = n == null ? void 0 : n.weekStartsOn) !== null && i !== void 0 ? i : n == null || (o = n.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && e !== void 0 ? e : h.weekStartsOn) !== null && t !== void 0 ? t : (u = h.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(v >= 0 && v <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var g = c(a), p = g.getDay(), _ = (p < v ? 7 : 0) + p - v;
  return g.setDate(g.getDate() - _), g.setHours(0, 0, 0, 0), g;
}
function ln(a, n) {
  var r, t, e, i, o, s, u, l;
  d(1, arguments);
  var h = c(a), v = h.getFullYear(), g = R(), p = b((r = (t = (e = (i = n == null ? void 0 : n.firstWeekContainsDate) !== null && i !== void 0 ? i : n == null || (o = n.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && e !== void 0 ? e : g.firstWeekContainsDate) !== null && t !== void 0 ? t : (u = g.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(p >= 1 && p <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var _ = /* @__PURE__ */ new Date(0);
  _.setFullYear(v + 1, 0, p), _.setHours(0, 0, 0, 0);
  var U = ee(_, n), Y = /* @__PURE__ */ new Date(0);
  Y.setFullYear(v, 0, p), Y.setHours(0, 0, 0, 0);
  var H = ee(Y, n);
  return h.getTime() >= U.getTime() ? v + 1 : h.getTime() >= H.getTime() ? v : v - 1;
}
function dn(a, n) {
  var r, t, e, i, o, s, u, l;
  d(1, arguments);
  var h = R(), v = b((r = (t = (e = (i = n == null ? void 0 : n.firstWeekContainsDate) !== null && i !== void 0 ? i : n == null || (o = n.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && e !== void 0 ? e : h.firstWeekContainsDate) !== null && t !== void 0 ? t : (u = h.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), g = ln(a, n), p = /* @__PURE__ */ new Date(0);
  p.setFullYear(g, 0, v), p.setHours(0, 0, 0, 0);
  var _ = ee(p, n);
  return _;
}
var cn = 6048e5;
function fn(a, n) {
  d(1, arguments);
  var r = c(a), t = ee(r, n).getTime() - dn(r, n).getTime();
  return Math.round(t / cn) + 1;
}
function mn(a) {
  return d(1, arguments), c(a).getFullYear();
}
function Ie(a, n) {
  d(2, arguments);
  var r = c(a), t = c(n);
  return r.getTime() > t.getTime();
}
function ce(a, n) {
  d(2, arguments);
  var r = c(a), t = c(n);
  return r.getTime() < t.getTime();
}
function vn(a, n) {
  d(2, arguments);
  var r = c(a), t = c(n);
  return r.getTime() === t.getTime();
}
function hn(a, n) {
  d(2, arguments);
  var r = ne(a), t = ne(n);
  return r.getTime() === t.getTime();
}
function pn(a, n) {
  d(2, arguments);
  var r = c(a), t = c(n);
  return r.getFullYear() === t.getFullYear();
}
function gn(a, n) {
  d(2, arguments);
  var r = c(a), t = c(n);
  return r.getFullYear() === t.getFullYear() && r.getMonth() === t.getMonth();
}
function ut(a) {
  d(1, arguments);
  var n = c(a);
  return n.setMinutes(0, 0, 0), n;
}
function wn(a, n) {
  d(2, arguments);
  var r = ut(a), t = ut(n);
  return r.getTime() === t.getTime();
}
function lt(a, n) {
  (n == null || n > a.length) && (n = a.length);
  for (var r = 0, t = Array(n); r < n; r++) t[r] = a[r];
  return t;
}
function yn(a, n) {
  if (a) {
    if (typeof a == "string") return lt(a, n);
    var r = {}.toString.call(a).slice(8, -1);
    return r === "Object" && a.constructor && (r = a.constructor.name), r === "Map" || r === "Set" ? Array.from(a) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? lt(a, n) : void 0;
  }
}
function dt(a, n) {
  var r = typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (!r) {
    if (Array.isArray(a) || (r = yn(a)) || n) {
      r && (a = r);
      var t = 0, e = function() {
      };
      return {
        s: e,
        n: function() {
          return t >= a.length ? {
            done: !0
          } : {
            done: !1,
            value: a[t++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: e
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, o = !0, s = !1;
  return {
    s: function() {
      r = r.call(a);
    },
    n: function() {
      var l = r.next();
      return o = l.done, l;
    },
    e: function(l) {
      s = !0, i = l;
    },
    f: function() {
      try {
        o || r.return == null || r.return();
      } finally {
        if (s) throw i;
      }
    }
  };
}
function Tn(a, n) {
  if (a == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in n)
    Object.prototype.hasOwnProperty.call(n, r) && (a[r] = n[r]);
  return a;
}
function x(a, n) {
  if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: a,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(a, "prototype", {
    writable: !1
  }), n && It(a, n);
}
function _e(a) {
  return _e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, _e(a);
}
function Dt() {
  try {
    var a = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Dt = function() {
    return !!a;
  })();
}
function bn(a, n) {
  if (n && (z(n) == "object" || typeof n == "function")) return n;
  if (n !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return m(a);
}
function D(a) {
  var n = Dt();
  return function() {
    var r, t = _e(a);
    if (n) {
      var e = _e(this).constructor;
      r = Reflect.construct(t, arguments, e);
    } else r = t.apply(this, arguments);
    return bn(this, r);
  };
}
function y(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function xn(a, n) {
  if (z(a) != "object" || !a) return a;
  var r = a[Symbol.toPrimitive];
  if (r !== void 0) {
    var t = r.call(a, n || "default");
    if (z(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(a);
}
function _t(a) {
  var n = xn(a, "string");
  return z(n) == "symbol" ? n : n + "";
}
function Dn(a, n) {
  for (var r = 0; r < n.length; r++) {
    var t = n[r];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(a, _t(t.key), t);
  }
}
function T(a, n, r) {
  return n && Dn(a.prototype, n), Object.defineProperty(a, "prototype", {
    writable: !1
  }), a;
}
function f(a, n, r) {
  return (n = _t(n)) in a ? Object.defineProperty(a, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[n] = r, a;
}
var _n = 10, Mt = /* @__PURE__ */ function() {
  function a() {
    y(this, a), f(this, "priority", void 0), f(this, "subPriority", 0);
  }
  return T(a, [{
    key: "validate",
    value: function(r, t) {
      return !0;
    }
  }]), a;
}(), Mn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r(t, e, i, o, s) {
    var u;
    return y(this, r), u = n.call(this), u.value = t, u.validateValue = e, u.setValue = i, u.priority = o, s && (u.subPriority = s), u;
  }
  return T(r, [{
    key: "validate",
    value: function(e, i) {
      return this.validateValue(e, this.value, i);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return this.setValue(e, i, this.value, o);
    }
  }]), r;
}(Mt), Cn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", _n), f(m(t), "subPriority", -1), t;
  }
  return T(r, [{
    key: "set",
    value: function(e, i) {
      if (i.timestampIsSet)
        return e;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), o.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), o;
    }
  }]), r;
}(Mt), M = /* @__PURE__ */ function() {
  function a() {
    y(this, a), f(this, "incompatibleTokens", void 0), f(this, "priority", void 0), f(this, "subPriority", void 0);
  }
  return T(a, [{
    key: "run",
    value: function(r, t, e, i) {
      var o = this.parse(r, t, e, i);
      return o ? {
        setter: new Mn(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, t, e) {
      return !0;
    }
  }]), a;
}(), kn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 140), f(m(t), "incompatibleTokens", ["R", "u", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return o.era(e, {
            width: "abbreviated"
          }) || o.era(e, {
            width: "narrow"
          });
        case "GGGGG":
          return o.era(e, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return o.era(e, {
            width: "wide"
          }) || o.era(e, {
            width: "abbreviated"
          }) || o.era(e, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return i.era = o, e.setUTCFullYear(o, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(M), P = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, A = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function j(a, n) {
  return a && {
    value: n(a.value),
    rest: a.rest
  };
}
function k(a, n) {
  var r = n.match(a);
  return r ? {
    value: parseInt(r[0], 10),
    rest: n.slice(r[0].length)
  } : null;
}
function $(a, n) {
  var r = n.match(a);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  var t = r[1] === "+" ? 1 : -1, e = r[2] ? parseInt(r[2], 10) : 0, i = r[3] ? parseInt(r[3], 10) : 0, o = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: t * (e * Oe + i * ke + o * er),
    rest: n.slice(r[0].length)
  };
}
function Ct(a) {
  return k(P.anyDigitsSigned, a);
}
function O(a, n) {
  switch (a) {
    case 1:
      return k(P.singleDigit, n);
    case 2:
      return k(P.twoDigits, n);
    case 3:
      return k(P.threeDigits, n);
    case 4:
      return k(P.fourDigits, n);
    default:
      return k(new RegExp("^\\d{1," + a + "}"), n);
  }
}
function Me(a, n) {
  switch (a) {
    case 1:
      return k(P.singleDigitSigned, n);
    case 2:
      return k(P.twoDigitsSigned, n);
    case 3:
      return k(P.threeDigitsSigned, n);
    case 4:
      return k(P.fourDigitsSigned, n);
    default:
      return k(new RegExp("^-?\\d{1," + a + "}"), n);
  }
}
function qe(a) {
  switch (a) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function kt(a, n) {
  var r = n > 0, t = r ? n : 1 - n, e;
  if (t <= 50)
    e = a || 100;
  else {
    var i = t + 50, o = Math.floor(i / 100) * 100, s = a >= i % 100;
    e = a + o - (s ? 100 : 0);
  }
  return r ? e : 1 - e;
}
function Ot(a) {
  return a % 400 === 0 || a % 4 === 0 && a % 100 !== 0;
}
var On = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 130), f(m(t), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(l) {
        return {
          year: l,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return j(O(4, e), s);
        case "yo":
          return j(o.ordinalNumber(e, {
            unit: "year"
          }), s);
        default:
          return j(O(i.length, e), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = e.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var u = kt(o.year, s);
        return e.setUTCFullYear(u, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
      }
      var l = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return e.setUTCFullYear(l, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(M), Pn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 130), f(m(t), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(l) {
        return {
          year: l,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return j(O(4, e), s);
        case "Yo":
          return j(o.ordinalNumber(e, {
            unit: "year"
          }), s);
        default:
          return j(O(i.length, e), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      var u = Re(e, s);
      if (o.isTwoDigitYear) {
        var l = kt(o.year, u);
        return e.setUTCFullYear(l, 0, s.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), te(e, s);
      }
      var h = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return e.setUTCFullYear(h, 0, s.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), te(e, s);
    }
  }]), r;
}(M), jn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 130), f(m(t), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i) {
      return Me(i === "R" ? 4 : i.length, e);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), ae(s);
    }
  }]), r;
}(M), Yn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 130), f(m(t), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i) {
      return Me(i === "u" ? 4 : i.length, e);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCFullYear(o, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(M), En = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 120), f(m(t), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "Q":
        case "QQ":
          return O(i.length, e);
        case "Qo":
          return o.ordinalNumber(e, {
            unit: "quarter"
          });
        case "QQQ":
          return o.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return o.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return o.quarter(e, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth((o - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(M), Nn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 120), f(m(t), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "q":
        case "qq":
          return O(i.length, e);
        case "qo":
          return o.ordinalNumber(e, {
            unit: "quarter"
          });
        case "qqq":
          return o.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return o.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return o.quarter(e, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth((o - 1) * 3, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(M), Un = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), f(m(t), "priority", 110), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(l) {
        return l - 1;
      };
      switch (i) {
        case "M":
          return j(k(P.month, e), s);
        case "MM":
          return j(O(2, e), s);
        case "Mo":
          return j(o.ordinalNumber(e, {
            unit: "month"
          }), s);
        case "MMM":
          return o.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(e, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return o.month(e, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return o.month(e, {
            width: "wide",
            context: "formatting"
          }) || o.month(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth(o, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(M), Wn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 110), f(m(t), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(l) {
        return l - 1;
      };
      switch (i) {
        case "L":
          return j(k(P.month, e), s);
        case "LL":
          return j(O(2, e), s);
        case "Lo":
          return j(o.ordinalNumber(e, {
            unit: "month"
          }), s);
        case "LLL":
          return o.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(e, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return o.month(e, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return o.month(e, {
            width: "wide",
            context: "standalone"
          }) || o.month(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth(o, 1), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(M);
function Hn(a, n, r) {
  d(2, arguments);
  var t = c(a), e = b(n), i = wt(t, r) - e;
  return t.setUTCDate(t.getUTCDate() - i * 7), t;
}
var In = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 100), f(m(t), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "w":
          return k(P.week, e);
        case "wo":
          return o.ordinalNumber(e, {
            unit: "week"
          });
        default:
          return O(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      return te(Hn(e, o, s), s);
    }
  }]), r;
}(M);
function Ln(a, n) {
  d(2, arguments);
  var r = c(a), t = b(n), e = gt(r) - t;
  return r.setUTCDate(r.getUTCDate() - e * 7), r;
}
var Fn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 100), f(m(t), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "I":
          return k(P.week, e);
        case "Io":
          return o.ordinalNumber(e, {
            unit: "week"
          });
        default:
          return O(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return ae(Ln(e, o));
    }
  }]), r;
}(M), Sn = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], An = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], $n = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 90), f(m(t), "subPriority", 1), f(m(t), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "d":
          return k(P.date, e);
        case "do":
          return o.ordinalNumber(e, {
            unit: "date"
          });
        default:
          return O(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      var o = e.getUTCFullYear(), s = Ot(o), u = e.getUTCMonth();
      return s ? i >= 1 && i <= An[u] : i >= 1 && i <= Sn[u];
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCDate(o), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(M), Rn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 90), f(m(t), "subpriority", 1), f(m(t), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "D":
        case "DD":
          return k(P.dayOfYear, e);
        case "Do":
          return o.ordinalNumber(e, {
            unit: "date"
          });
        default:
          return O(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      var o = e.getUTCFullYear(), s = Ot(o);
      return s ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMonth(0, o), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(M);
function Qe(a, n, r) {
  var t, e, i, o, s, u, l, h;
  d(2, arguments);
  var v = R(), g = b((t = (e = (i = (o = r == null ? void 0 : r.weekStartsOn) !== null && o !== void 0 ? o : r == null || (s = r.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && i !== void 0 ? i : v.weekStartsOn) !== null && e !== void 0 ? e : (l = v.locale) === null || l === void 0 || (h = l.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && t !== void 0 ? t : 0);
  if (!(g >= 0 && g <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = c(a), _ = b(n), U = p.getUTCDay(), Y = _ % 7, H = (Y + 7) % 7, S = (H < g ? 7 : 0) + _ - U;
  return p.setUTCDate(p.getUTCDate() + S), p;
}
var qn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 90), f(m(t), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return o.day(e, {
            width: "wide",
            context: "formatting"
          }) || o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      return e = Qe(e, o, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(M), Qn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 90), f(m(t), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o, s) {
      var u = function(h) {
        var v = Math.floor((h - 1) / 7) * 7;
        return (h + s.weekStartsOn + 6) % 7 + v;
      };
      switch (i) {
        case "e":
        case "ee":
          return j(O(i.length, e), u);
        case "eo":
          return j(o.ordinalNumber(e, {
            unit: "day"
          }), u);
        case "eee":
          return o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return o.day(e, {
            width: "wide",
            context: "formatting"
          }) || o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      return e = Qe(e, o, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(M), Bn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 90), f(m(t), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o, s) {
      var u = function(h) {
        var v = Math.floor((h - 1) / 7) * 7;
        return (h + s.weekStartsOn + 6) % 7 + v;
      };
      switch (i) {
        case "c":
        case "cc":
          return j(O(i.length, e), u);
        case "co":
          return j(o.ordinalNumber(e, {
            unit: "day"
          }), u);
        case "ccc":
          return o.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(e, {
            width: "short",
            context: "standalone"
          }) || o.day(e, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return o.day(e, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return o.day(e, {
            width: "short",
            context: "standalone"
          }) || o.day(e, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return o.day(e, {
            width: "wide",
            context: "standalone"
          }) || o.day(e, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(e, {
            width: "short",
            context: "standalone"
          }) || o.day(e, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(e, i, o, s) {
      return e = Qe(e, o, s), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(M);
function zn(a, n) {
  d(2, arguments);
  var r = b(n);
  r % 7 === 0 && (r = r - 7);
  var t = 1, e = c(a), i = e.getUTCDay(), o = r % 7, s = (o + 7) % 7, u = (s < t ? 7 : 0) + r - i;
  return e.setUTCDate(e.getUTCDate() + u), e;
}
var Gn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 90), f(m(t), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      var s = function(l) {
        return l === 0 ? 7 : l;
      };
      switch (i) {
        case "i":
        case "ii":
          return O(i.length, e);
        case "io":
          return o.ordinalNumber(e, {
            unit: "day"
          });
        case "iii":
          return j(o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiii":
          return j(o.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiiii":
          return j(o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiii":
        default:
          return j(o.day(e, {
            width: "wide",
            context: "formatting"
          }) || o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e = zn(e, o), e.setUTCHours(0, 0, 0, 0), e;
    }
  }]), r;
}(M), Xn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 80), f(m(t), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCHours(qe(o), 0, 0, 0), e;
    }
  }]), r;
}(M), Zn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 80), f(m(t), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCHours(qe(o), 0, 0, 0), e;
    }
  }]), r;
}(M), Vn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 80), f(m(t), "incompatibleTokens", ["a", "b", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(e, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(e, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCHours(qe(o), 0, 0, 0), e;
    }
  }]), r;
}(M), Kn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 70), f(m(t), "incompatibleTokens", ["H", "K", "k", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "h":
          return k(P.hour12h, e);
        case "ho":
          return o.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return O(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = e.getUTCHours() >= 12;
      return s && o < 12 ? e.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? e.setUTCHours(0, 0, 0, 0) : e.setUTCHours(o, 0, 0, 0), e;
    }
  }]), r;
}(M), Jn = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 70), f(m(t), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "H":
          return k(P.hour23h, e);
        case "Ho":
          return o.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return O(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCHours(o, 0, 0, 0), e;
    }
  }]), r;
}(M), ea = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 70), f(m(t), "incompatibleTokens", ["h", "H", "k", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "K":
          return k(P.hour11h, e);
        case "Ko":
          return o.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return O(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = e.getUTCHours() >= 12;
      return s && o < 12 ? e.setUTCHours(o + 12, 0, 0, 0) : e.setUTCHours(o, 0, 0, 0), e;
    }
  }]), r;
}(M), ta = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 70), f(m(t), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "k":
          return k(P.hour24h, e);
        case "ko":
          return o.ordinalNumber(e, {
            unit: "hour"
          });
        default:
          return O(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      var s = o <= 24 ? o % 24 : o;
      return e.setUTCHours(s, 0, 0, 0), e;
    }
  }]), r;
}(M), ra = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 60), f(m(t), "incompatibleTokens", ["t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "m":
          return k(P.minute, e);
        case "mo":
          return o.ordinalNumber(e, {
            unit: "minute"
          });
        default:
          return O(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMinutes(o, 0, 0), e;
    }
  }]), r;
}(M), na = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 50), f(m(t), "incompatibleTokens", ["t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i, o) {
      switch (i) {
        case "s":
          return k(P.second, e);
        case "so":
          return o.ordinalNumber(e, {
            unit: "second"
          });
        default:
          return O(i.length, e);
      }
    }
  }, {
    key: "validate",
    value: function(e, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCSeconds(o, 0), e;
    }
  }]), r;
}(M), aa = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 30), f(m(t), "incompatibleTokens", ["t", "T"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i) {
      var o = function(u) {
        return Math.floor(u * Math.pow(10, -i.length + 3));
      };
      return j(O(i.length, e), o);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return e.setUTCMilliseconds(o), e;
    }
  }]), r;
}(M), oa = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 10), f(m(t), "incompatibleTokens", ["t", "T", "x"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i) {
      switch (i) {
        case "X":
          return $(A.basicOptionalMinutes, e);
        case "XX":
          return $(A.basic, e);
        case "XXXX":
          return $(A.basicOptionalSeconds, e);
        case "XXXXX":
          return $(A.extendedOptionalSeconds, e);
        case "XXX":
        default:
          return $(A.extended, e);
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return i.timestampIsSet ? e : new Date(e.getTime() - o);
    }
  }]), r;
}(M), ia = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 10), f(m(t), "incompatibleTokens", ["t", "T", "X"]), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e, i) {
      switch (i) {
        case "x":
          return $(A.basicOptionalMinutes, e);
        case "xx":
          return $(A.basic, e);
        case "xxxx":
          return $(A.basicOptionalSeconds, e);
        case "xxxxx":
          return $(A.extendedOptionalSeconds, e);
        case "xxx":
        default:
          return $(A.extended, e);
      }
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return i.timestampIsSet ? e : new Date(e.getTime() - o);
    }
  }]), r;
}(M), sa = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 40), f(m(t), "incompatibleTokens", "*"), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e) {
      return Ct(e);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(M), ua = /* @__PURE__ */ function(a) {
  x(r, a);
  var n = D(r);
  function r() {
    var t;
    y(this, r);
    for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++)
      i[o] = arguments[o];
    return t = n.call.apply(n, [this].concat(i)), f(m(t), "priority", 20), f(m(t), "incompatibleTokens", "*"), t;
  }
  return T(r, [{
    key: "parse",
    value: function(e) {
      return Ct(e);
    }
  }, {
    key: "set",
    value: function(e, i, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(M), la = {
  G: new kn(),
  y: new On(),
  Y: new Pn(),
  R: new jn(),
  u: new Yn(),
  Q: new En(),
  q: new Nn(),
  M: new Un(),
  L: new Wn(),
  w: new In(),
  I: new Fn(),
  d: new $n(),
  D: new Rn(),
  E: new qn(),
  e: new Qn(),
  c: new Bn(),
  i: new Gn(),
  a: new Xn(),
  b: new Zn(),
  B: new Vn(),
  h: new Kn(),
  H: new Jn(),
  K: new ea(),
  k: new ta(),
  m: new ra(),
  s: new na(),
  S: new aa(),
  X: new oa(),
  x: new ia(),
  t: new sa(),
  T: new ua()
}, da = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ca = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, fa = /^'([^]*?)'?$/, ma = /''/g, va = /\S/, ha = /[a-zA-Z]/;
function pa(a, n, r, t) {
  var e, i, o, s, u, l, h, v, g, p, _, U, Y, H, S, q, Q, V;
  d(3, arguments);
  var W = String(a), L = String(n), B = R(), G = (e = (i = t == null ? void 0 : t.locale) !== null && i !== void 0 ? i : B.locale) !== null && e !== void 0 ? e : je;
  if (!G.match)
    throw new RangeError("locale must contain match property");
  var X = b((o = (s = (u = (l = t == null ? void 0 : t.firstWeekContainsDate) !== null && l !== void 0 ? l : t == null || (h = t.locale) === null || h === void 0 || (v = h.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && u !== void 0 ? u : B.firstWeekContainsDate) !== null && s !== void 0 ? s : (g = B.locale) === null || g === void 0 || (p = g.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(X >= 1 && X <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var oe = b((_ = (U = (Y = (H = t == null ? void 0 : t.weekStartsOn) !== null && H !== void 0 ? H : t == null || (S = t.locale) === null || S === void 0 || (q = S.options) === null || q === void 0 ? void 0 : q.weekStartsOn) !== null && Y !== void 0 ? Y : B.weekStartsOn) !== null && U !== void 0 ? U : (Q = B.locale) === null || Q === void 0 || (V = Q.options) === null || V === void 0 ? void 0 : V.weekStartsOn) !== null && _ !== void 0 ? _ : 0);
  if (!(oe >= 0 && oe <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (L === "")
    return W === "" ? c(r) : /* @__PURE__ */ new Date(NaN);
  var ie = {
    firstWeekContainsDate: X,
    weekStartsOn: oe,
    locale: G
  }, se = [new Cn()], Ye = L.match(ca).map(function(E) {
    var C = E[0];
    if (C in Ae) {
      var F = Ae[C];
      return F(E, G.formatLong);
    }
    return E;
  }).join("").match(da), N = [], I = dt(Ye), K;
  try {
    var jt = function() {
      var C = K.value;
      !(t != null && t.useAdditionalWeekYearTokens) && bt(C) && De(C, L, a), !(t != null && t.useAdditionalDayOfYearTokens) && Tt(C) && De(C, L, a);
      var F = C[0], ge = la[F];
      if (ge) {
        var Ze = ge.incompatibleTokens;
        if (Array.isArray(Ze)) {
          var Ve = N.find(function(Ke) {
            return Ze.includes(Ke.token) || Ke.token === F;
          });
          if (Ve)
            throw new RangeError("The format string mustn't contain `".concat(Ve.fullToken, "` and `").concat(C, "` at the same time"));
        } else if (ge.incompatibleTokens === "*" && N.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(C, "` and any other token at the same time"));
        N.push({
          token: F,
          fullToken: C
        });
        var Ne = ge.run(W, C, G.match, ie);
        if (!Ne)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        se.push(Ne.setter), W = Ne.rest;
      } else {
        if (F.match(ha))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + F + "`");
        if (C === "''" ? C = "'" : F === "'" && (C = ga(C)), W.indexOf(C) === 0)
          W = W.slice(C.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (I.s(); !(K = I.n()).done; ) {
      var Be = jt();
      if (z(Be) === "object") return Be.v;
    }
  } catch (E) {
    I.e(E);
  } finally {
    I.f();
  }
  if (W.length > 0 && va.test(W))
    return /* @__PURE__ */ new Date(NaN);
  var Yt = se.map(function(E) {
    return E.priority;
  }).sort(function(E, C) {
    return C - E;
  }).filter(function(E, C, F) {
    return F.indexOf(E) === C;
  }).map(function(E) {
    return se.filter(function(C) {
      return C.priority === E;
    }).sort(function(C, F) {
      return F.subPriority - C.subPriority;
    });
  }).map(function(E) {
    return E[0];
  }), Ee = c(r);
  if (isNaN(Ee.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var ue = ht(Ee, xe(Ee)), ze = {}, he = dt(Yt), Ge;
  try {
    for (he.s(); !(Ge = he.n()).done; ) {
      var Xe = Ge.value;
      if (!Xe.validate(ue, ie))
        return /* @__PURE__ */ new Date(NaN);
      var pe = Xe.set(ue, ze, ie);
      Array.isArray(pe) ? (ue = pe[0], Tn(ze, pe[1])) : ue = pe;
    }
  } catch (E) {
    he.e(E);
  } finally {
    he.f();
  }
  return ue;
}
function ga(a) {
  return a.match(fa)[1].replace(ma, "'");
}
function wa(a, n) {
  d(2, arguments);
  var r = c(a), t = b(n);
  return r.setDate(t), r;
}
function ya(a, n) {
  d(2, arguments);
  var r = c(a), t = b(n);
  return r.setHours(t), r;
}
function Ta(a, n) {
  d(2, arguments);
  var r = c(a), t = b(n);
  return r.setMinutes(t), r;
}
function ba(a, n) {
  d(2, arguments);
  var r = c(a), t = b(n), e = r.getFullYear(), i = r.getDate(), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(e, t, 15), o.setHours(0, 0, 0, 0);
  var s = xt(o);
  return r.setMonth(t, Math.min(i, s)), r;
}
function xa(a, n) {
  d(2, arguments);
  var r = c(a), t = b(n);
  return r.setSeconds(t), r;
}
function Da(a, n) {
  d(2, arguments);
  var r = c(a), t = b(n);
  return r.setMilliseconds(t), r;
}
function _a(a, n) {
  d(2, arguments);
  var r = c(a), t = b(n);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date(NaN) : (r.setFullYear(t), r);
}
function ct(a) {
  d(1, arguments);
  var n = c(a);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function we(a) {
  d(1, arguments);
  var n = c(a), r = /* @__PURE__ */ new Date(0);
  return r.setFullYear(n.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function Ma(a, n) {
  var r;
  d(1, arguments);
  var t = b((r = void 0) !== null && r !== void 0 ? r : 2);
  if (t !== 2 && t !== 1 && t !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof a == "string" || Object.prototype.toString.call(a) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var e = Pa(a), i;
  if (e.date) {
    var o = ja(e.date, t);
    i = Ya(o.restDateString, o.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var s = i.getTime(), u = 0, l;
  if (e.time && (u = Ea(e.time), isNaN(u)))
    return /* @__PURE__ */ new Date(NaN);
  if (e.timezone) {
    if (l = Na(e.timezone), isNaN(l))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var h = new Date(s + u), v = /* @__PURE__ */ new Date(0);
    return v.setFullYear(h.getUTCFullYear(), h.getUTCMonth(), h.getUTCDate()), v.setHours(h.getUTCHours(), h.getUTCMinutes(), h.getUTCSeconds(), h.getUTCMilliseconds()), v;
  }
  return new Date(s + u + l);
}
var ye = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Ca = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, ka = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Oa = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Pa(a) {
  var n = {}, r = a.split(ye.dateTimeDelimiter), t;
  if (r.length > 2)
    return n;
  if (/:/.test(r[0]) ? t = r[0] : (n.date = r[0], t = r[1], ye.timeZoneDelimiter.test(n.date) && (n.date = a.split(ye.timeZoneDelimiter)[0], t = a.substr(n.date.length, a.length))), t) {
    var e = ye.timezone.exec(t);
    e ? (n.time = t.replace(e[1], ""), n.timezone = e[1]) : n.time = t;
  }
  return n;
}
function ja(a, n) {
  var r = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + n) + "})|(\\d{2}|[+-]\\d{" + (2 + n) + "})$)"), t = a.match(r);
  if (!t) return {
    year: NaN,
    restDateString: ""
  };
  var e = t[1] ? parseInt(t[1]) : null, i = t[2] ? parseInt(t[2]) : null;
  return {
    year: i === null ? e : i * 100,
    restDateString: a.slice((t[1] || t[2]).length)
  };
}
function Ya(a, n) {
  if (n === null) return /* @__PURE__ */ new Date(NaN);
  var r = a.match(Ca);
  if (!r) return /* @__PURE__ */ new Date(NaN);
  var t = !!r[4], e = fe(r[1]), i = fe(r[2]) - 1, o = fe(r[3]), s = fe(r[4]), u = fe(r[5]) - 1;
  if (t)
    return La(n, s, u) ? Ua(n, s, u) : /* @__PURE__ */ new Date(NaN);
  var l = /* @__PURE__ */ new Date(0);
  return !Ha(n, i, o) || !Ia(n, e) ? /* @__PURE__ */ new Date(NaN) : (l.setUTCFullYear(n, i, Math.max(e, o)), l);
}
function fe(a) {
  return a ? parseInt(a) : 1;
}
function Ea(a) {
  var n = a.match(ka);
  if (!n) return NaN;
  var r = Le(n[1]), t = Le(n[2]), e = Le(n[3]);
  return Fa(r, t, e) ? r * Oe + t * ke + e * 1e3 : NaN;
}
function Le(a) {
  return a && parseFloat(a.replace(",", ".")) || 0;
}
function Na(a) {
  if (a === "Z") return 0;
  var n = a.match(Oa);
  if (!n) return 0;
  var r = n[1] === "+" ? -1 : 1, t = parseInt(n[2]), e = n[3] && parseInt(n[3]) || 0;
  return Sa(t, e) ? r * (t * Oe + e * ke) : NaN;
}
function Ua(a, n, r) {
  var t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(a, 0, 4);
  var e = t.getUTCDay() || 7, i = (n - 1) * 7 + r + 1 - e;
  return t.setUTCDate(t.getUTCDate() + i), t;
}
var Wa = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Pt(a) {
  return a % 400 === 0 || a % 4 === 0 && a % 100 !== 0;
}
function Ha(a, n, r) {
  return n >= 0 && n <= 11 && r >= 1 && r <= (Wa[n] || (Pt(a) ? 29 : 28));
}
function Ia(a, n) {
  return n >= 1 && n <= (Pt(a) ? 366 : 365);
}
function La(a, n, r) {
  return n >= 1 && n <= 53 && r >= 0 && r <= 6;
}
function Fa(a, n, r) {
  return a === 24 ? n === 0 && r === 0 : r >= 0 && r < 60 && n >= 0 && n < 60 && a >= 0 && a < 25;
}
function Sa(a, n) {
  return n >= 0 && n <= 59;
}
function Aa(a, n) {
  var r, t;
  d(1, arguments);
  var e = c(a);
  if (isNaN(e.getTime()))
    throw new RangeError("Invalid time value");
  var i = String((r = n == null ? void 0 : n.format) !== null && r !== void 0 ? r : "extended"), o = String((t = n == null ? void 0 : n.representation) !== null && t !== void 0 ? t : "complete");
  if (i !== "extended" && i !== "basic")
    throw new RangeError("format must be 'extended' or 'basic'");
  if (o !== "date" && o !== "time" && o !== "complete")
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  var s = "", u = "", l = i === "extended" ? "-" : "", h = i === "extended" ? ":" : "";
  if (o !== "time") {
    var v = w(e.getDate(), 2), g = w(e.getMonth() + 1, 2), p = w(e.getFullYear(), 4);
    s = "".concat(p).concat(l).concat(g).concat(l).concat(v);
  }
  if (o !== "date") {
    var _ = e.getTimezoneOffset();
    if (_ !== 0) {
      var U = Math.abs(_), Y = w(Math.floor(U / 60), 2), H = w(U % 60, 2), S = _ < 0 ? "+" : "-";
      u = "".concat(S).concat(Y, ":").concat(H);
    } else
      u = "Z";
    var q = w(e.getHours(), 2), Q = w(e.getMinutes(), 2), V = w(e.getSeconds(), 2), W = s === "" ? "" : "T", L = [q, Q, V].join(h);
    s = "".concat(s).concat(W).concat(L).concat(u);
  }
  return s;
}
function $a(a, n) {
  d(2, arguments);
  var r = c(a).getTime(), t = c(n.start).getTime(), e = c(n.end).getTime();
  if (!(t <= e))
    throw new RangeError("Invalid interval");
  return r >= t && r <= e;
}
var $e = { exports: {} };
(function(a, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = void 0;
  var r = function(u, l) {
    switch (u) {
      case "P":
        return l.date({
          width: "short"
        });
      case "PP":
        return l.date({
          width: "medium"
        });
      case "PPP":
        return l.date({
          width: "long"
        });
      case "PPPP":
      default:
        return l.date({
          width: "full"
        });
    }
  }, t = function(u, l) {
    switch (u) {
      case "p":
        return l.time({
          width: "short"
        });
      case "pp":
        return l.time({
          width: "medium"
        });
      case "ppp":
        return l.time({
          width: "long"
        });
      case "pppp":
      default:
        return l.time({
          width: "full"
        });
    }
  }, e = function(u, l) {
    var h = u.match(/(P+)(p+)?/) || [], v = h[1], g = h[2];
    if (!g)
      return r(u, l);
    var p;
    switch (v) {
      case "P":
        p = l.dateTime({
          width: "short"
        });
        break;
      case "PP":
        p = l.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        p = l.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        p = l.dateTime({
          width: "full"
        });
        break;
    }
    return p.replace("{{date}}", r(v, l)).replace("{{time}}", t(g, l));
  }, i = {
    p: t,
    P: e
  }, o = i;
  n.default = o, a.exports = n.default;
})($e, $e.exports);
var Ra = $e.exports;
const qa = /* @__PURE__ */ Lt(Ra), Qa = {
  // Year
  y: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yy: "year",
  yyy: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yyyy: "year",
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  L: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  LL: "month",
  LLL: {
    sectionType: "month",
    contentType: "letter"
  },
  LLLL: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  d: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  dd: "day",
  do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  E: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  i: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ii: "weekDay",
  iii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  iiii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  e: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ee: "weekDay",
  eee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  c: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  cc: "weekDay",
  ccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  a: "meridiem",
  aa: "meridiem",
  aaa: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, Ba = {
  year: "yyyy",
  month: "LLLL",
  monthShort: "MMM",
  dayOfMonth: "d",
  weekday: "EEEE",
  weekdayShort: "EEEEEE",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "aa",
  minutes: "mm",
  seconds: "ss",
  fullDate: "PP",
  fullDateWithWeekday: "PPPP",
  keyboardDate: "P",
  shortDate: "MMM d",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  monthAndYear: "LLLL yyyy",
  monthAndDate: "MMMM d",
  fullTime: "p",
  fullTime12h: "hh:mm aa",
  fullTime24h: "HH:mm",
  fullDateTime: "PP p",
  fullDateTime12h: "PP hh:mm aa",
  fullDateTime24h: "PP HH:mm",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aa",
  keyboardDateTime24h: "P HH:mm"
};
class za {
  constructor(n) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !1, this.lib = "date-fns", this.locale = void 0, this.formats = void 0, this.formatTokenMap = Qa, this.escapedCharacters = {
      start: "'",
      end: "'"
    }, this.longFormatters = void 0, this.date = (i) => typeof i > "u" ? /* @__PURE__ */ new Date() : i === null ? null : new Date(i), this.dateWithTimezone = (i) => this.date(i), this.getTimezone = () => "default", this.setTimezone = (i) => i, this.toJsDate = (i) => i, this.getCurrentLocaleCode = () => {
      var i;
      return ((i = this.locale) == null ? void 0 : i.code) || "en-US";
    }, this.is12HourCycleInCurrentLocale = () => this.locale ? /a/.test(this.locale.formatLong.time({
      width: "short"
    })) : !0, this.expandFormat = (i) => {
      const o = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      return i.match(o).map((s) => {
        const u = s[0];
        if (u === "p" || u === "P") {
          const l = this.longFormatters[u];
          return l(s, this.locale.formatLong);
        }
        return s;
      }).join("");
    }, this.getFormatHelperText = (i) => this.expandFormat(i).replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase(), this.isNull = (i) => i === null, this.formatNumber = (i) => i, this.getMeridiemText = (i) => i === "am" ? "AM" : "PM";
    const {
      locale: r,
      formats: t,
      longFormatters: e
    } = n;
    this.locale = r, this.formats = Wt({}, Ba, t), this.longFormatters = e;
  }
}
class Ga extends za {
  constructor({
    locale: n,
    formats: r
  } = {}) {
    if (typeof Te != "function")
      throw new Error(["MUI: The `date-fns` package v3.x is not compatible with this adapter.", "Please, install v2.x of the package or use the `AdapterDateFnsV3` instead."].join(`
`));
    super({
      locale: n ?? je,
      formats: r,
      longFormatters: qa
    }), this.parseISO = (t) => Ma(t), this.toISO = (t) => Aa(t, {
      format: "extended"
    }), this.parse = (t, e) => t === "" ? null : pa(t, e, /* @__PURE__ */ new Date(), {
      locale: this.locale
    }), this.isValid = (t) => vt(this.date(t)), this.format = (t, e) => this.formatByString(t, this.formats[e]), this.formatByString = (t, e) => en(t, e, {
      locale: this.locale
    }), this.getDiff = (t, e, i) => {
      switch (i) {
        case "years":
          return Bt(t, this.date(e));
        case "quarters":
          return Zt(t, this.date(e));
        case "months":
          return ft(t, this.date(e));
        case "weeks":
          return Jt(t, this.date(e));
        case "days":
          return mt(t, this.date(e));
        case "hours":
          return tr(t, this.date(e));
        case "minutes":
          return rr(t, this.date(e));
        case "seconds":
          return nr(t, this.date(e));
        default:
          return Pe(t, this.date(e));
      }
    }, this.isEqual = (t, e) => t === null && e === null ? !0 : vn(t, e), this.isSameYear = (t, e) => pn(t, e), this.isSameMonth = (t, e) => gn(t, e), this.isSameDay = (t, e) => hn(t, e), this.isSameHour = (t, e) => wn(t, e), this.isAfter = (t, e) => Ie(t, e), this.isAfterYear = (t, e) => Ie(t, We(e)), this.isAfterDay = (t, e) => Ie(t, Fe(e)), this.isBefore = (t, e) => ce(t, e), this.isBeforeYear = (t, e) => ce(t, we(e)), this.isBeforeDay = (t, e) => ce(t, ne(e)), this.isWithinRange = (t, [e, i]) => $a(t, {
      start: e,
      end: i
    }), this.startOfYear = (t) => we(t), this.startOfMonth = (t) => ct(t), this.startOfWeek = (t) => ee(t, {
      locale: this.locale
    }), this.startOfDay = (t) => ne(t), this.endOfYear = (t) => We(t), this.endOfMonth = (t) => Se(t), this.endOfWeek = (t) => Ue(t, {
      locale: this.locale
    }), this.endOfDay = (t) => Fe(t), this.addYears = (t, e) => tt(t, e), this.addMonths = (t, e) => be(t, e), this.addWeeks = (t, e) => qt(t, e), this.addDays = (t, e) => Te(t, e), this.addHours = (t, e) => Rt(t, e), this.addMinutes = (t, e) => At(t, e), this.addSeconds = (t, e) => Ft(t, e), this.getYear = (t) => mn(t), this.getMonth = (t) => on(t), this.getDate = (t) => rn(t), this.getHours = (t) => nn(t), this.getMinutes = (t) => an(t), this.getSeconds = (t) => sn(t), this.getMilliseconds = (t) => un(t), this.setYear = (t, e) => _a(t, e), this.setMonth = (t, e) => ba(t, e), this.setDate = (t, e) => wa(t, e), this.setHours = (t, e) => ya(t, e), this.setMinutes = (t, e) => Ta(t, e), this.setSeconds = (t, e) => xa(t, e), this.setMilliseconds = (t, e) => Da(t, e), this.getDaysInMonth = (t) => xt(t), this.getNextMonth = (t) => be(t, 1), this.getPreviousMonth = (t) => be(t, -1), this.getMonthArray = (t) => {
      const i = [we(t)];
      for (; i.length < 12; ) {
        const o = i[i.length - 1];
        i.push(this.getNextMonth(o));
      }
      return i;
    }, this.mergeDateAndTime = (t, e) => this.setSeconds(this.setMinutes(this.setHours(t, this.getHours(e)), this.getMinutes(e)), this.getSeconds(e)), this.getWeekdays = () => {
      const t = /* @__PURE__ */ new Date();
      return ar({
        start: ee(t, {
          locale: this.locale
        }),
        end: Ue(t, {
          locale: this.locale
        })
      }).map((e) => this.formatByString(e, "EEEEEE"));
    }, this.getWeekArray = (t) => {
      const e = ee(ct(t), {
        locale: this.locale
      }), i = Ue(Se(t), {
        locale: this.locale
      });
      let o = 0, s = e;
      const u = [];
      for (; ce(s, i); ) {
        const l = Math.floor(o / 7);
        u[l] = u[l] || [], u[l].push(s), s = Te(s, 1), o += 1;
      }
      return u;
    }, this.getWeekNumber = (t) => fn(t, {
      locale: this.locale
    }), this.getYearRange = (t, e) => {
      const i = we(t), o = We(e), s = [];
      let u = i;
      for (; ce(u, o); )
        s.push(u), u = tt(u, 1);
      return s;
    };
  }
}
function Xa(a) {
  const n = {
    languageCode: "",
    countryCode: ""
  };
  if (!a)
    return n;
  const [r, t] = a.split("-");
  return n.languageCode = r, n.countryCode = t, n;
}
async function Za(a) {
  let n;
  const { languageCode: r, countryCode: t } = Xa(a);
  if (t)
    try {
      n = await et(/* @__PURE__ */ Object.assign({ "../../node_modules/date-fns/esm/locale/af/index.js": () => import("./chunk.BzTsLbbJ.js"), "../../node_modules/date-fns/esm/locale/ar-DZ/index.js": () => import("./chunk.D1prJ14a.js"), "../../node_modules/date-fns/esm/locale/ar-EG/index.js": () => import("./chunk.Cuc-P9MT.js"), "../../node_modules/date-fns/esm/locale/ar-MA/index.js": () => import("./chunk.CTLcn7On.js"), "../../node_modules/date-fns/esm/locale/ar-SA/index.js": () => import("./chunk.CJrZtkRi.js"), "../../node_modules/date-fns/esm/locale/ar-TN/index.js": () => import("./chunk.BAk_L_Oe.js"), "../../node_modules/date-fns/esm/locale/ar/index.js": () => import("./chunk.B0VymyDl.js"), "../../node_modules/date-fns/esm/locale/az/index.js": () => import("./chunk.CpBNqDh0.js"), "../../node_modules/date-fns/esm/locale/be-tarask/index.js": () => import("./chunk.DAzb2fp1.js"), "../../node_modules/date-fns/esm/locale/be/index.js": () => import("./chunk.DiMKd1R3.js"), "../../node_modules/date-fns/esm/locale/bg/index.js": () => import("./chunk.cReBPi5j.js"), "../../node_modules/date-fns/esm/locale/bn/index.js": () => import("./chunk.QJnqktJY.js"), "../../node_modules/date-fns/esm/locale/bs/index.js": () => import("./chunk.DDt4xWxK.js"), "../../node_modules/date-fns/esm/locale/ca/index.js": () => import("./chunk.DZpiKX-K.js"), "../../node_modules/date-fns/esm/locale/cs/index.js": () => import("./chunk.BEAJVp88.js"), "../../node_modules/date-fns/esm/locale/cy/index.js": () => import("./chunk.C0N63R9J.js"), "../../node_modules/date-fns/esm/locale/da/index.js": () => import("./chunk.D6DfYdDo.js"), "../../node_modules/date-fns/esm/locale/de-AT/index.js": () => import("./chunk.CIjcMHtE.js"), "../../node_modules/date-fns/esm/locale/de/index.js": () => import("./chunk.CzUwQr0q.js"), "../../node_modules/date-fns/esm/locale/el/index.js": () => import("./chunk.B2ODzIHJ.js"), "../../node_modules/date-fns/esm/locale/en-AU/index.js": () => import("./chunk.CAyY9cE3.js"), "../../node_modules/date-fns/esm/locale/en-CA/index.js": () => import("./chunk.Cc8IttHv.js"), "../../node_modules/date-fns/esm/locale/en-GB/index.js": () => import("./chunk.DAJ41j8o.js"), "../../node_modules/date-fns/esm/locale/en-IE/index.js": () => import("./chunk.Bi1Dl5Iq.js"), "../../node_modules/date-fns/esm/locale/en-IN/index.js": () => import("./chunk.BP6Z6bNA.js"), "../../node_modules/date-fns/esm/locale/en-NZ/index.js": () => import("./chunk.CO0nXOHr.js"), "../../node_modules/date-fns/esm/locale/en-US/index.js": () => Promise.resolve().then(() => st), "../../node_modules/date-fns/esm/locale/en-ZA/index.js": () => import("./chunk.DCt1VFhm.js"), "../../node_modules/date-fns/esm/locale/eo/index.js": () => import("./chunk.Bbm2CSzx.js"), "../../node_modules/date-fns/esm/locale/es/index.js": () => import("./chunk.RlFrjJS7.js"), "../../node_modules/date-fns/esm/locale/et/index.js": () => import("./chunk.BJARKmAc.js"), "../../node_modules/date-fns/esm/locale/eu/index.js": () => import("./chunk.DZvsqiu9.js"), "../../node_modules/date-fns/esm/locale/fa-IR/index.js": () => import("./chunk.DlBb-nRE.js"), "../../node_modules/date-fns/esm/locale/fi/index.js": () => import("./chunk.GCnItu0z.js"), "../../node_modules/date-fns/esm/locale/fr-CA/index.js": () => import("./chunk.u-czcbZv.js"), "../../node_modules/date-fns/esm/locale/fr-CH/index.js": () => import("./chunk.D2_lYadB.js"), "../../node_modules/date-fns/esm/locale/fr/index.js": () => import("./chunk.W75GzeQA.js"), "../../node_modules/date-fns/esm/locale/fy/index.js": () => import("./chunk.Cy-tBHeK.js"), "../../node_modules/date-fns/esm/locale/gd/index.js": () => import("./chunk.Bj6Bl6al.js"), "../../node_modules/date-fns/esm/locale/gl/index.js": () => import("./chunk.C36whHWn.js"), "../../node_modules/date-fns/esm/locale/gu/index.js": () => import("./chunk.CllnYuiP.js"), "../../node_modules/date-fns/esm/locale/he/index.js": () => import("./chunk.D0rXfcO8.js"), "../../node_modules/date-fns/esm/locale/hi/index.js": () => import("./chunk.Bq21ne1_.js"), "../../node_modules/date-fns/esm/locale/hr/index.js": () => import("./chunk.CiTI8wE0.js"), "../../node_modules/date-fns/esm/locale/ht/index.js": () => import("./chunk.D-N5Hb2L.js"), "../../node_modules/date-fns/esm/locale/hu/index.js": () => import("./chunk.CvJjEGXg.js"), "../../node_modules/date-fns/esm/locale/hy/index.js": () => import("./chunk.NatltESR.js"), "../../node_modules/date-fns/esm/locale/id/index.js": () => import("./chunk.zegvzzVp.js"), "../../node_modules/date-fns/esm/locale/is/index.js": () => import("./chunk._eCkG0Yo.js"), "../../node_modules/date-fns/esm/locale/it-CH/index.js": () => import("./chunk.ByU2XZ0a.js"), "../../node_modules/date-fns/esm/locale/it/index.js": () => import("./chunk.D8LBIK1c.js"), "../../node_modules/date-fns/esm/locale/ja-Hira/index.js": () => import("./chunk.bQJXr002.js"), "../../node_modules/date-fns/esm/locale/ja/index.js": () => import("./chunk.DyFyfscY.js"), "../../node_modules/date-fns/esm/locale/ka/index.js": () => import("./chunk.B6oxp42f.js"), "../../node_modules/date-fns/esm/locale/kk/index.js": () => import("./chunk.jgmIOViT.js"), "../../node_modules/date-fns/esm/locale/km/index.js": () => import("./chunk.aTiAIpfP.js"), "../../node_modules/date-fns/esm/locale/kn/index.js": () => import("./chunk.BnTyGvW1.js"), "../../node_modules/date-fns/esm/locale/ko/index.js": () => import("./chunk.QrqALLoK.js"), "../../node_modules/date-fns/esm/locale/lb/index.js": () => import("./chunk.B79LcnMj.js"), "../../node_modules/date-fns/esm/locale/lt/index.js": () => import("./chunk.BpKEl5TI.js"), "../../node_modules/date-fns/esm/locale/lv/index.js": () => import("./chunk.DDkLGQu9.js"), "../../node_modules/date-fns/esm/locale/mk/index.js": () => import("./chunk.CNZYXVtB.js"), "../../node_modules/date-fns/esm/locale/mn/index.js": () => import("./chunk.BkNQZWYK.js"), "../../node_modules/date-fns/esm/locale/ms/index.js": () => import("./chunk.DzK4lw0l.js"), "../../node_modules/date-fns/esm/locale/mt/index.js": () => import("./chunk.1a-x5-PK.js"), "../../node_modules/date-fns/esm/locale/nb/index.js": () => import("./chunk.D1SWnn0E.js"), "../../node_modules/date-fns/esm/locale/nl-BE/index.js": () => import("./chunk.DvAgStzY.js"), "../../node_modules/date-fns/esm/locale/nl/index.js": () => import("./chunk.D2nFHISN.js"), "../../node_modules/date-fns/esm/locale/nn/index.js": () => import("./chunk.BEKGVUrG.js"), "../../node_modules/date-fns/esm/locale/oc/index.js": () => import("./chunk.CJSmyg9f.js"), "../../node_modules/date-fns/esm/locale/pl/index.js": () => import("./chunk.C0NOOoK6.js"), "../../node_modules/date-fns/esm/locale/pt-BR/index.js": () => import("./chunk.BS488w1g.js"), "../../node_modules/date-fns/esm/locale/pt/index.js": () => import("./chunk.CObqNGmA.js"), "../../node_modules/date-fns/esm/locale/ro/index.js": () => import("./chunk.DFhpkMCC.js"), "../../node_modules/date-fns/esm/locale/ru/index.js": () => import("./chunk.O90Vq5sh.js"), "../../node_modules/date-fns/esm/locale/sk/index.js": () => import("./chunk.CekBxjYg.js"), "../../node_modules/date-fns/esm/locale/sl/index.js": () => import("./chunk.CMzhJMjr.js"), "../../node_modules/date-fns/esm/locale/sq/index.js": () => import("./chunk.CCAJb-9_.js"), "../../node_modules/date-fns/esm/locale/sr-Latn/index.js": () => import("./chunk.CjGe1SOc.js"), "../../node_modules/date-fns/esm/locale/sr/index.js": () => import("./chunk.pr-DZ2Fx.js"), "../../node_modules/date-fns/esm/locale/sv/index.js": () => import("./chunk.CkDpJJsD.js"), "../../node_modules/date-fns/esm/locale/ta/index.js": () => import("./chunk.DSaSjjAp.js"), "../../node_modules/date-fns/esm/locale/te/index.js": () => import("./chunk.CQN9zYl_.js"), "../../node_modules/date-fns/esm/locale/th/index.js": () => import("./chunk.C47FPA8Q.js"), "../../node_modules/date-fns/esm/locale/tr/index.js": () => import("./chunk.iLe45OXF.js"), "../../node_modules/date-fns/esm/locale/ug/index.js": () => import("./chunk.BZegseMi.js"), "../../node_modules/date-fns/esm/locale/uk/index.js": () => import("./chunk.BsxvTiAC.js"), "../../node_modules/date-fns/esm/locale/uz-Cyrl/index.js": () => import("./chunk.VfuBhjdg.js"), "../../node_modules/date-fns/esm/locale/uz/index.js": () => import("./chunk.BnKgZW74.js"), "../../node_modules/date-fns/esm/locale/vi/index.js": () => import("./chunk.CcmQduUK.js"), "../../node_modules/date-fns/esm/locale/zh-CN/index.js": () => import("./chunk.DXJu10q6.js"), "../../node_modules/date-fns/esm/locale/zh-HK/index.js": () => import("./chunk.CjHUxThs.js"), "../../node_modules/date-fns/esm/locale/zh-TW/index.js": () => import("./chunk.087abIUn.js") }), `../../node_modules/date-fns/esm/locale/${a}/index.js`, 8);
    } catch {
    }
  return n || (n = await et(/* @__PURE__ */ Object.assign({ "../../node_modules/date-fns/esm/locale/af/index.js": () => import("./chunk.BzTsLbbJ.js"), "../../node_modules/date-fns/esm/locale/ar-DZ/index.js": () => import("./chunk.D1prJ14a.js"), "../../node_modules/date-fns/esm/locale/ar-EG/index.js": () => import("./chunk.Cuc-P9MT.js"), "../../node_modules/date-fns/esm/locale/ar-MA/index.js": () => import("./chunk.CTLcn7On.js"), "../../node_modules/date-fns/esm/locale/ar-SA/index.js": () => import("./chunk.CJrZtkRi.js"), "../../node_modules/date-fns/esm/locale/ar-TN/index.js": () => import("./chunk.BAk_L_Oe.js"), "../../node_modules/date-fns/esm/locale/ar/index.js": () => import("./chunk.B0VymyDl.js"), "../../node_modules/date-fns/esm/locale/az/index.js": () => import("./chunk.CpBNqDh0.js"), "../../node_modules/date-fns/esm/locale/be-tarask/index.js": () => import("./chunk.DAzb2fp1.js"), "../../node_modules/date-fns/esm/locale/be/index.js": () => import("./chunk.DiMKd1R3.js"), "../../node_modules/date-fns/esm/locale/bg/index.js": () => import("./chunk.cReBPi5j.js"), "../../node_modules/date-fns/esm/locale/bn/index.js": () => import("./chunk.QJnqktJY.js"), "../../node_modules/date-fns/esm/locale/bs/index.js": () => import("./chunk.DDt4xWxK.js"), "../../node_modules/date-fns/esm/locale/ca/index.js": () => import("./chunk.DZpiKX-K.js"), "../../node_modules/date-fns/esm/locale/cs/index.js": () => import("./chunk.BEAJVp88.js"), "../../node_modules/date-fns/esm/locale/cy/index.js": () => import("./chunk.C0N63R9J.js"), "../../node_modules/date-fns/esm/locale/da/index.js": () => import("./chunk.D6DfYdDo.js"), "../../node_modules/date-fns/esm/locale/de-AT/index.js": () => import("./chunk.CIjcMHtE.js"), "../../node_modules/date-fns/esm/locale/de/index.js": () => import("./chunk.CzUwQr0q.js"), "../../node_modules/date-fns/esm/locale/el/index.js": () => import("./chunk.B2ODzIHJ.js"), "../../node_modules/date-fns/esm/locale/en-AU/index.js": () => import("./chunk.CAyY9cE3.js"), "../../node_modules/date-fns/esm/locale/en-CA/index.js": () => import("./chunk.Cc8IttHv.js"), "../../node_modules/date-fns/esm/locale/en-GB/index.js": () => import("./chunk.DAJ41j8o.js"), "../../node_modules/date-fns/esm/locale/en-IE/index.js": () => import("./chunk.Bi1Dl5Iq.js"), "../../node_modules/date-fns/esm/locale/en-IN/index.js": () => import("./chunk.BP6Z6bNA.js"), "../../node_modules/date-fns/esm/locale/en-NZ/index.js": () => import("./chunk.CO0nXOHr.js"), "../../node_modules/date-fns/esm/locale/en-US/index.js": () => Promise.resolve().then(() => st), "../../node_modules/date-fns/esm/locale/en-ZA/index.js": () => import("./chunk.DCt1VFhm.js"), "../../node_modules/date-fns/esm/locale/eo/index.js": () => import("./chunk.Bbm2CSzx.js"), "../../node_modules/date-fns/esm/locale/es/index.js": () => import("./chunk.RlFrjJS7.js"), "../../node_modules/date-fns/esm/locale/et/index.js": () => import("./chunk.BJARKmAc.js"), "../../node_modules/date-fns/esm/locale/eu/index.js": () => import("./chunk.DZvsqiu9.js"), "../../node_modules/date-fns/esm/locale/fa-IR/index.js": () => import("./chunk.DlBb-nRE.js"), "../../node_modules/date-fns/esm/locale/fi/index.js": () => import("./chunk.GCnItu0z.js"), "../../node_modules/date-fns/esm/locale/fr-CA/index.js": () => import("./chunk.u-czcbZv.js"), "../../node_modules/date-fns/esm/locale/fr-CH/index.js": () => import("./chunk.D2_lYadB.js"), "../../node_modules/date-fns/esm/locale/fr/index.js": () => import("./chunk.W75GzeQA.js"), "../../node_modules/date-fns/esm/locale/fy/index.js": () => import("./chunk.Cy-tBHeK.js"), "../../node_modules/date-fns/esm/locale/gd/index.js": () => import("./chunk.Bj6Bl6al.js"), "../../node_modules/date-fns/esm/locale/gl/index.js": () => import("./chunk.C36whHWn.js"), "../../node_modules/date-fns/esm/locale/gu/index.js": () => import("./chunk.CllnYuiP.js"), "../../node_modules/date-fns/esm/locale/he/index.js": () => import("./chunk.D0rXfcO8.js"), "../../node_modules/date-fns/esm/locale/hi/index.js": () => import("./chunk.Bq21ne1_.js"), "../../node_modules/date-fns/esm/locale/hr/index.js": () => import("./chunk.CiTI8wE0.js"), "../../node_modules/date-fns/esm/locale/ht/index.js": () => import("./chunk.D-N5Hb2L.js"), "../../node_modules/date-fns/esm/locale/hu/index.js": () => import("./chunk.CvJjEGXg.js"), "../../node_modules/date-fns/esm/locale/hy/index.js": () => import("./chunk.NatltESR.js"), "../../node_modules/date-fns/esm/locale/id/index.js": () => import("./chunk.zegvzzVp.js"), "../../node_modules/date-fns/esm/locale/is/index.js": () => import("./chunk._eCkG0Yo.js"), "../../node_modules/date-fns/esm/locale/it-CH/index.js": () => import("./chunk.ByU2XZ0a.js"), "../../node_modules/date-fns/esm/locale/it/index.js": () => import("./chunk.D8LBIK1c.js"), "../../node_modules/date-fns/esm/locale/ja-Hira/index.js": () => import("./chunk.bQJXr002.js"), "../../node_modules/date-fns/esm/locale/ja/index.js": () => import("./chunk.DyFyfscY.js"), "../../node_modules/date-fns/esm/locale/ka/index.js": () => import("./chunk.B6oxp42f.js"), "../../node_modules/date-fns/esm/locale/kk/index.js": () => import("./chunk.jgmIOViT.js"), "../../node_modules/date-fns/esm/locale/km/index.js": () => import("./chunk.aTiAIpfP.js"), "../../node_modules/date-fns/esm/locale/kn/index.js": () => import("./chunk.BnTyGvW1.js"), "../../node_modules/date-fns/esm/locale/ko/index.js": () => import("./chunk.QrqALLoK.js"), "../../node_modules/date-fns/esm/locale/lb/index.js": () => import("./chunk.B79LcnMj.js"), "../../node_modules/date-fns/esm/locale/lt/index.js": () => import("./chunk.BpKEl5TI.js"), "../../node_modules/date-fns/esm/locale/lv/index.js": () => import("./chunk.DDkLGQu9.js"), "../../node_modules/date-fns/esm/locale/mk/index.js": () => import("./chunk.CNZYXVtB.js"), "../../node_modules/date-fns/esm/locale/mn/index.js": () => import("./chunk.BkNQZWYK.js"), "../../node_modules/date-fns/esm/locale/ms/index.js": () => import("./chunk.DzK4lw0l.js"), "../../node_modules/date-fns/esm/locale/mt/index.js": () => import("./chunk.1a-x5-PK.js"), "../../node_modules/date-fns/esm/locale/nb/index.js": () => import("./chunk.D1SWnn0E.js"), "../../node_modules/date-fns/esm/locale/nl-BE/index.js": () => import("./chunk.DvAgStzY.js"), "../../node_modules/date-fns/esm/locale/nl/index.js": () => import("./chunk.D2nFHISN.js"), "../../node_modules/date-fns/esm/locale/nn/index.js": () => import("./chunk.BEKGVUrG.js"), "../../node_modules/date-fns/esm/locale/oc/index.js": () => import("./chunk.CJSmyg9f.js"), "../../node_modules/date-fns/esm/locale/pl/index.js": () => import("./chunk.C0NOOoK6.js"), "../../node_modules/date-fns/esm/locale/pt-BR/index.js": () => import("./chunk.BS488w1g.js"), "../../node_modules/date-fns/esm/locale/pt/index.js": () => import("./chunk.CObqNGmA.js"), "../../node_modules/date-fns/esm/locale/ro/index.js": () => import("./chunk.DFhpkMCC.js"), "../../node_modules/date-fns/esm/locale/ru/index.js": () => import("./chunk.O90Vq5sh.js"), "../../node_modules/date-fns/esm/locale/sk/index.js": () => import("./chunk.CekBxjYg.js"), "../../node_modules/date-fns/esm/locale/sl/index.js": () => import("./chunk.CMzhJMjr.js"), "../../node_modules/date-fns/esm/locale/sq/index.js": () => import("./chunk.CCAJb-9_.js"), "../../node_modules/date-fns/esm/locale/sr-Latn/index.js": () => import("./chunk.CjGe1SOc.js"), "../../node_modules/date-fns/esm/locale/sr/index.js": () => import("./chunk.pr-DZ2Fx.js"), "../../node_modules/date-fns/esm/locale/sv/index.js": () => import("./chunk.CkDpJJsD.js"), "../../node_modules/date-fns/esm/locale/ta/index.js": () => import("./chunk.DSaSjjAp.js"), "../../node_modules/date-fns/esm/locale/te/index.js": () => import("./chunk.CQN9zYl_.js"), "../../node_modules/date-fns/esm/locale/th/index.js": () => import("./chunk.C47FPA8Q.js"), "../../node_modules/date-fns/esm/locale/tr/index.js": () => import("./chunk.iLe45OXF.js"), "../../node_modules/date-fns/esm/locale/ug/index.js": () => import("./chunk.BZegseMi.js"), "../../node_modules/date-fns/esm/locale/uk/index.js": () => import("./chunk.BsxvTiAC.js"), "../../node_modules/date-fns/esm/locale/uz-Cyrl/index.js": () => import("./chunk.VfuBhjdg.js"), "../../node_modules/date-fns/esm/locale/uz/index.js": () => import("./chunk.BnKgZW74.js"), "../../node_modules/date-fns/esm/locale/vi/index.js": () => import("./chunk.CcmQduUK.js"), "../../node_modules/date-fns/esm/locale/zh-CN/index.js": () => import("./chunk.DXJu10q6.js"), "../../node_modules/date-fns/esm/locale/zh-HK/index.js": () => import("./chunk.CjHUxThs.js"), "../../node_modules/date-fns/esm/locale/zh-TW/index.js": () => import("./chunk.087abIUn.js") }), `../../node_modules/date-fns/esm/locale/${r}/index.js`, 8)), n == null ? void 0 : n.default;
}
function ro(a) {
  var i;
  let n = !0;
  const r = a.localeCode || navigator.language, [t, e] = Et({
    localeCode: null,
    locale: null
  });
  return Nt(() => {
    if (r !== t.localeCode) {
      if (!r) {
        n && e({
          localeCode: r,
          locale: null
        });
        return;
      }
      Za(r).then((o) => {
        n && e({
          localeCode: r,
          locale: o
        });
      }).catch((o) => {
        n && console.error(
          `Error encountered while importing locale "${r}": ${o.message || o}`
        );
      });
    }
    return function() {
      n = !1;
    };
  }, [r]), /* @__PURE__ */ Je.createElement(
    Ut.Provider,
    {
      value: { code: (i = t == null ? void 0 : t.locale) != null && i.code ? t.locale.code : null }
    },
    /* @__PURE__ */ Je.createElement(
      Ht,
      {
        dateAdapter: Ga,
        adapterLocale: t.locale ? t.locale : void 0
      },
      a.children
    )
  );
}
export {
  ro as L,
  _r as a,
  He as b,
  le as c,
  Wr as d,
  de as e,
  wr as f,
  Er as l,
  Gr as m,
  d as r,
  te as s,
  c as t
};
